
import { AdjustmentTypePolicy } from "constants/charge/AdjustmentTypePolicy";
import { PaymentModePolicy } from "constants/charge/PaymentModePolicy";
import { ChargeDetailEntity, EMPTY_CHARGE_DETAIL_ENTITY } from "domain/entity/ChargeDetailMaintenance/ChargeDetailEntity";
import { CollectionDetailEntity, EMPTY_COLLECTION_DETAIL_ENTITY } from "domain/entity/Collection/CollectionDetailEntity";
import { CollectionHeaderEntity } from "domain/entity/Collection/CollectionHeaderEntity";
import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { AdditionChargeVesselEntity } from "domain/entity/CounterCustomerCharge/AdditionChargeVesselEntity";
import { CounterCustomerChargeEntity, EMPTY_COUNTER_CUSTOMER_CHARGE_ENTITY } from "domain/entity/CounterCustomerCharge/CounterCustomerChargeEntity";
import { CounterCustomerChargeSearchCriteria, EMPTY_COUNTER_CUSTOMER_CHARGE_SEARCH_CRITERIA } from "domain/entity/CounterCustomerCharge/CounterCustomerChargeSearchCriteria";
import { ExtensionPaymentCriteria } from "domain/entity/CounterCustomerCharge/ExtensionPaymentCriteria";
import { ImportReHandlingCriteria } from "domain/entity/CounterCustomerCharge/ImportReHandlingCriteria";
import { EMPTY_PAYMENT_MODE_ADDITIONAL_INFO_CRITERIA, PaymentModeAdditionalInfoCriteria } from "domain/entity/CounterCustomerCharge/PaymentModeAdditionalInfoCriteria";
import { MasterDataType } from "domain/entity/MasterData/MasterDataEntity";
import { BankerRepository } from "domain/repository/Banker/BankerRepo";
import { ChargeDetailRepository } from "domain/repository/ChargeDetailMaintenance/ChargeDetailRepo";
import { ChargeTypeRepository } from "domain/repository/ChargeType/ChargeTypeRepo";
import { CompanyRepository } from "domain/repository/Company/CompanyRepo";
import { CounterCustomerChargeRepository } from "domain/repository/CounterCustomerCharge/CounterCustomerChargeRepo";
import { MasterDataRepository } from "domain/repository/MasterData/MasterDataRepo";
import { OpsLineRepository } from "domain/repository/OpsLine/OpsLineRepo";
import { ParameterDetailRepository } from "domain/repository/parameter/ParameterDetailRepo";
import { RequestServiceCodeRepository } from "domain/repository/RequestServiceCode/RequestServiceCodeRepo";
import { StandardTariffCodeRepository } from "domain/repository/TariffCode/StandardTariffCodeRepo";
import _ from "lodash";
import { updateAccountTerminalValidationSchema } from "presentation/constant/CounterCustomerCharge/AccountTerminalValidationSchema";
import { createAdditionalChargeValidationSchema, createCntrAdditionalChargeValidationSchema, createUomAdditionalChargeValidationSchema } from "presentation/constant/CounterCustomerCharge/AdditionalChargeValidationSchema";
import { updateAdjustmentValidationSchema } from "presentation/constant/CounterCustomerCharge/AdjustmentValidationSchema";
import { createPaymentModeForCashValidationSchema, createPaymentModeForOnlineValidationSchema, createPaymentModeForPosValidationSchema, createPaymentModeForPoValidationSchema, createPaymentModeHeaderForAQCTIBValidationSchema, createPaymentModeHeaderForAQCTOBValidationSchema } from "presentation/constant/CounterCustomerCharge/PaymentModeAndAdditionInfoValidationSchema";
import { CntrStatusDroOpts } from "presentation/constant/DropDownOptions/Company/CntrStatusDroOpts";
import { Validation } from "presentation/constant/Validation";
import { AgentDeliveryDateState, CounterCustomerChargeMaintenanceModel, PaidThroughDateState } from "presentation/model/CounterCustomerCharge/CounterCustomerChargeMaintenanceModel";
import { DropdownProps } from "presentation/model/DropdownProps";
import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";
import { updateBillToCompanyValidationSchema, updateChargeOnCompanyValidationSchema } from "presentation/constant/CounterCustomerCharge/UpdateCompanyValidationSchema";

interface CounterCustomerChargeMaintenanceVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<CounterCustomerChargeMaintenanceModel>> | ((value: SetStateAction<CounterCustomerChargeMaintenanceModel>) => void),
    ],
    repo: CounterCustomerChargeRepository,
    chargeTypeRepo: ChargeTypeRepository,
    opsLineRepo: OpsLineRepository,
    companyRepo: CompanyRepository,
    masterDataRepo: MasterDataRepository,
    parameterDetailRepo: ParameterDetailRepository,
    standardTariffCodeRepo: StandardTariffCodeRepository,
    requestServiceCodeRepo: RequestServiceCodeRepository,
    bankerRepo: BankerRepository,
    chargeDetail: ChargeDetailRepository,
}

export const CounterCustomerChargeMaintenanceVM = ({ dispatch, repo, chargeTypeRepo, opsLineRepo, companyRepo, masterDataRepo, parameterDetailRepo, standardTariffCodeRepo, requestServiceCodeRepo, bankerRepo, chargeDetail }: CounterCustomerChargeMaintenanceVMProps) => {
    const [counterCustomerChargeMainDispatch] = dispatch;

    const onShowLoading = () => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                isLoading: true,
            }
        })
    }

    const onHideLoading = () => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                isLoading: false,
            }
        })
    }
    const loadDropdownOption = async () => {

        const [chargeTypes, opsLines, companies, serviceCodes, cntrSizes,
            cntrTypes, waiverReason, acctTmlReason, tariffs, reqServiceCodeList, bankers] = await Promise.all([
                chargeTypeRepo.getAllChargeTypesForCombobox(),
                opsLineRepo.getOpsLineForCombobox(),
                companyRepo.getAllCompanyForCombobox(),
                masterDataRepo.getMasterDataByKey(MasterDataType.SERVICE),
                parameterDetailRepo.getAllParameterDtlsByParameterCode("CNTR_SIZE"),
                parameterDetailRepo.getAllParameterDtlsByParameterCode("CNTR_TYPE"),
                parameterDetailRepo.getAllParameterDtlsByParameterCode("WAIVER_REASON_CODE"),
                parameterDetailRepo.getAllParameterDtlsByParameterCode("ACCT_TML_REASON_CODE"),
                standardTariffCodeRepo.getAllStandardTariffCodes(),
                requestServiceCodeRepo.getEntities(),
                bankerRepo.getEntities(),
            ]);

        let newChargeTypes = _.orderBy(chargeTypes, ["chargeType", "subChargeType"]);
        let chargeTypeDropdownOptions: DropdownProps[] = [];
        let chargeTypeByUserDropdownOptions: DropdownProps[] = [];
        let subChargeTypeDropdownOptions: { [key: string]: DropdownProps[] } = {};
        let subChargeTypeByUserDropdownOptions: { [key: string]: DropdownProps[] } = {};
        newChargeTypes.forEach(chgTypeEty => {
            const chgTypeExisted = chargeTypeDropdownOptions?.find(chgType =>
                chgType.value === chgTypeEty.chargeType);
            if (!chgTypeExisted) {
                chargeTypeDropdownOptions.push({
                    dropdownLabel: chgTypeEty.chargeType,
                    tagLabel: chgTypeEty.chargeType,
                    value: chgTypeEty.chargeType
                })
            }
            if (chgTypeEty.chargeCategory === "USER") {
                const chgTypeByUserExisted = chargeTypeByUserDropdownOptions?.find(chgType =>
                    chgType.value === chgTypeEty.chargeType);
                if (!chgTypeByUserExisted) {
                    chargeTypeByUserDropdownOptions.push({
                        dropdownLabel: chgTypeEty.chargeType,
                        tagLabel: chgTypeEty.chargeType,
                        value: chgTypeEty.chargeType
                    })
                }
                if (chgTypeEty.subChargeType) {
                    if (!subChargeTypeByUserDropdownOptions[chgTypeEty.chargeType]) {
                        subChargeTypeByUserDropdownOptions[chgTypeEty.chargeType] = [];
                    }
                    subChargeTypeByUserDropdownOptions[chgTypeEty.chargeType].push({
                        dropdownLabel: chgTypeEty.subChargeType,
                        tagLabel: chgTypeEty.subChargeType,
                        value: chgTypeEty.subChargeType
                    });
                }
            }
            if (chgTypeEty.subChargeType) {
                if (!subChargeTypeDropdownOptions[chgTypeEty.chargeType]) {
                    subChargeTypeDropdownOptions[chgTypeEty.chargeType] = [];
                }
                subChargeTypeDropdownOptions[chgTypeEty.chargeType].push({
                    dropdownLabel: chgTypeEty.subChargeType,
                    tagLabel: chgTypeEty.subChargeType,
                    value: chgTypeEty.subChargeType
                });
            }
        });

        const opsLinesDropdownOptions = opsLines?.map((opsLineEntity) => ({
            dropdownLabel: opsLineEntity.opsLine,
            tagLabel: opsLineEntity.opsLine,
            value: opsLineEntity.opsLine,
        })) ?? []


        const agentNo = companies?.filter(comp => comp.customerType === 'Agent');
        let agentNoDropdownOptions = agentNo?.map((agent) => ({
            dropdownLabel: agent.companyCode,
            tagLabel: agent.companyCode,
            value: agent.companyCode
        })) ?? []
        agentNoDropdownOptions = _.orderBy(agentNoDropdownOptions, "dropdownLabel");

        const shipperConsignee = companies?.filter(comp =>
            comp.customerType === 'Shipper' || comp.customerType === 'Consignee' || comp.customerType === 'Both'
        );
        let shipperConsigneeDropdownOptions = shipperConsignee?.map((agent) => ({
            dropdownLabel: agent.companyCode,
            tagLabel: agent.companyCode,
            value: agent.companyCode
        })) ?? []
        shipperConsigneeDropdownOptions = _.orderBy(shipperConsigneeDropdownOptions, "dropdownLabel");

        let companyCodeDropdownOptions = companies?.filter((company) =>
            company.companyType !== 'MASTER' && company.companyType !== 'ALLIANCE'
        )?.map((company) => ({
            dropdownLabel: company.companyCode,
            tagLabel: company.companyCode,
            value: company.companyCode,
        })) ?? []
        companyCodeDropdownOptions = _.orderBy(companyCodeDropdownOptions, "dropdownLabel");

        const slCompanies = companies?.filter(comp =>
            comp.customerType === 'SL'
        );
        let allSLCompanies = slCompanies?.map((company) => company.companyCode) ?? [];

        const ccCompanies = companies?.filter(comp => comp.customerType !== 'SL' && comp.companyType !== 'MASTER' && comp.companyType !== 'ALLIANCE');
        let ccCompanyCodeDropdownOptions = ccCompanies?.map((company) => ({
            dropdownLabel: company.companyCode,
            tagLabel: company.companyCode,
            value: company.companyCode,
        })) ?? []
        ccCompanyCodeDropdownOptions = _.orderBy(ccCompanyCodeDropdownOptions, "dropdownLabel");

        let serviceCodeDropdownOptions = serviceCodes?.map((serviceCode) => ({
            dropdownLabel: serviceCode.code,
            tagLabel: serviceCode.code,
            value: serviceCode.code,
        })) ?? []
        serviceCodeDropdownOptions = _.orderBy(serviceCodeDropdownOptions, "dropdownLabel");


        const containerSizeDropdownOptions = cntrSizes?.map((containerSize) => ({
            dropdownLabel: containerSize.parameterDtlCode,
            tagLabel: containerSize.parameterDtlCode,
            value: containerSize.parameterDtlCode,
        })) ?? []

        const cntrTypeDropdownOptions = cntrTypes?.map((cntrType) => ({
            dropdownLabel: cntrType.parameterDtlCode,
            tagLabel: cntrType.parameterDtlCode,
            value: cntrType.parameterDtlCode,
        })) ?? []


        const waiverReasonCodeDropdownOptions = waiverReason?.map((waiverReason) => ({
            dropdownLabel: waiverReason.parameterDtlCode,
            tagLabel: waiverReason.parameterDtlCode,
            value: waiverReason.parameterDtlCode,
        })) ?? []


        let acctTmlReasonCodeDropdownOptions = acctTmlReason?.map((acctTmlReason) => ({
            dropdownLabel: acctTmlReason.parameterDtlCode,
            tagLabel: acctTmlReason.parameterDtlCode,
            value: acctTmlReason.parameterDtlCode,
        })) ?? []
        acctTmlReasonCodeDropdownOptions = _.orderBy(acctTmlReasonCodeDropdownOptions, "dropdownLabel");


        let newTariffs = _.orderBy(tariffs, ["tariffType", "tariffCode"]);
        let tariffTypeDropdownOptions: DropdownProps[] = [];
        let tariffCodeDropdownOptions: { [key: string]: DropdownProps[] } = {};

        newTariffs?.forEach(tariff => {
            const isTariffTypeExisted = tariffTypeDropdownOptions?.find(t =>
                t.value === tariff.tariffType);
            if (!isTariffTypeExisted) {
                tariffTypeDropdownOptions.push({
                    dropdownLabel: tariff.tariffType,
                    tagLabel: tariff.tariffType,
                    value: tariff.tariffType,
                })
            }

            if (tariff.tariffCode) {
                if (!tariffCodeDropdownOptions[tariff.tariffType]) {
                    tariffCodeDropdownOptions[tariff.tariffType] = [];
                }
                tariffCodeDropdownOptions[tariff.tariffType].push({
                    dropdownLabel: tariff.tariffCode,
                    tagLabel: tariff.tariffCode,
                    value: tariff.tariffCode,
                })

            }
        })

        let reqServiceCodeDropdownOption: DropdownProps[] = [];
        let allSubReqServiceCodeDropdownOption: DropdownProps[] = [];
        let subReqServiceCodeDropdownOption: { [key: string]: DropdownProps[] } = {};

        let codeList = reqServiceCodeList?.filter(entity => entity.activeInd === 'Y');
        codeList?.forEach(entity => {
            const codeExisted = reqServiceCodeDropdownOption?.find(code =>
                code.value === entity.serviceRequestCode);
            if (!codeExisted) {
                reqServiceCodeDropdownOption.push({
                    dropdownLabel: entity.serviceRequestCode ?? '',
                    tagLabel: entity.serviceRequestCode ?? '',
                    value: entity.serviceRequestCode ?? '',
                })
            }
            const subCodeExisted = allSubReqServiceCodeDropdownOption?.find(code =>
                code.value === entity.subServiceRequestCode);
            if (!subCodeExisted) {
                allSubReqServiceCodeDropdownOption.push({
                    dropdownLabel: entity.subServiceRequestCode ?? '',
                    tagLabel: entity.subServiceRequestCode ?? '',
                    value: entity.subServiceRequestCode ?? '',
                })
            }
            if (entity.serviceRequestCode && entity.subServiceRequestCode) {
                if (!subReqServiceCodeDropdownOption[entity.serviceRequestCode]) {
                    subReqServiceCodeDropdownOption[entity.serviceRequestCode] = [];
                }
                subReqServiceCodeDropdownOption[entity.serviceRequestCode].push({
                    dropdownLabel: entity.subServiceRequestCode,
                    tagLabel: entity.subServiceRequestCode,
                    value: entity.subServiceRequestCode
                });
            }
        });

        let newBankers = bankers?.filter(entity => entity.activeInd === 'Y');
        let bankCodeDropdownOption = newBankers?.map((banker) => ({
            dropdownLabel: banker.bankCode,
            tagLabel: banker.bankCode,
            value: banker.bankCode,
        })) ?? []
        bankCodeDropdownOption = _.orderBy(bankCodeDropdownOption, "dropdownLabel");

        counterCustomerChargeMainDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                statusDropdownOptions: CntrStatusDroOpts().getDroOptsModel(),
                chgTypeDropdownOptions: chargeTypeDropdownOptions,
                chgTypeByUserDropdownOptions: chargeTypeByUserDropdownOptions,
                subChgTypeDropdownOptions: subChargeTypeDropdownOptions,
                subChgTypeByUserDropdownOptions: subChargeTypeByUserDropdownOptions,
                opsLineDropdownOptions: opsLinesDropdownOptions,
                billToCompDropdownOptions: companyCodeDropdownOptions,
                chgOnCompDropdownOptions: companyCodeDropdownOptions,
                agentNoDropdownOptions: agentNoDropdownOptions,
                shipperConsigneeDropdownOptions: shipperConsigneeDropdownOptions,
                allCCBillToCompDropdownOptions: ccCompanyCodeDropdownOptions,
                allCCChgOnCompDropdownOptions: ccCompanyCodeDropdownOptions,
                serviceCodeDropdownOptions: serviceCodeDropdownOptions,
                cntrSizeDropdownOptions: containerSizeDropdownOptions,
                cntrTypeDropdownOptions: cntrTypeDropdownOptions,
                waiverReasonCodeDropdownOptions: waiverReasonCodeDropdownOptions,
                acctTmlReasonCodeDropdownOptions: acctTmlReasonCodeDropdownOptions,
                tariffTypeDropdownOptions: tariffTypeDropdownOptions,
                tariffCodeDropdownOptions: tariffCodeDropdownOptions,
                serviceRequestCodeDropdownOptions: reqServiceCodeDropdownOption,
                subServiceRequestCodeDropdownOptions: subReqServiceCodeDropdownOption,
                allSubReqServiceCodeDropdownOptions: allSubReqServiceCodeDropdownOption,
                bankCodeDropdownOptions: bankCodeDropdownOption,
            },
            allSLCompanies: allSLCompanies
        }))

    }

    const onSearch = async (criteria: CounterCustomerChargeSearchCriteria, operatingUnit: string) => {
        counterCustomerChargeMainDispatch(prevState => ({
            ...prevState,
            // tableData: [],
            selectedRows: [],
            currentSelectedRow: EMPTY_COUNTER_CUSTOMER_CHARGE_ENTITY,
            isBackMaster: false,
            isShowDetailPanel: true,
            paymentModeState: {
                ...prevState.paymentModeState,
                allFormState: {},
                editingEntity: { ...EMPTY_COLLECTION_DETAIL_ENTITY },
                tableData: [],
                paymentModeHeader: { ...EMPTY_PAYMENT_MODE_ADDITIONAL_INFO_CRITERIA },
                isBankCode: false,
                isPayOrderNo: false,
                isPayOrderAmount: false,
                isCreditCardNo: false,
            },
            isShowPaymentModePanel: false,
            editWaiverList: [],
            suppleWaiverList: [],
            isShowSerachClose: false,
        }))
        let tableData: CounterCustomerChargeEntity[] = [];
        let msg: string | null = null;
        await repo.onlineSearchByCriteria(criteria).then(
            async res => {
                if (res.data) {
                    msg = res.data;
                }
                if (operatingUnit === 'AQCT' || operatingUnit === 'RSCT') {
                    await repo.cfsAndUnStuffingDownload(criteria).then(async data => {
                        tableData = await repo.searchByCriteria(criteria).then(
                            data => {
                                return data;
                            }
                        );
                    });
                } else {
                    tableData = await repo.searchByCriteria(criteria).then(
                        data => {
                            return data;
                        }
                    );
                }

                if (!_.isEmpty(tableData)) {
                    msg = null;
                }
                counterCustomerChargeMainDispatch(prevState => ({
                    ...prevState,
                    tableData: tableData
                }))
            }
        );
        // if (msg != null) {
        return msg;
        // }
    }

    const onSearchCounterCustomer = async (criteria: CounterCustomerChargeSearchCriteria) => {
        counterCustomerChargeMainDispatch(prevState => ({
            ...prevState,
            tableData: [],
            selectedRows: [],
            paidThroughDateMap: new Map(),
            agentDeliveryDateMap: new Map(),
            extensionPaymentMap: new Map(),
            selectedPaidThroughDateMap: new Map(),
            selectedAgentDeliveryDateMap: new Map(),
            currentSelectedRow: EMPTY_COUNTER_CUSTOMER_CHARGE_ENTITY,
            isBackMaster: false,
            isShowDetailPanel: true,
            isLoading: true,
            paymentModeState: {
                ...prevState.paymentModeState,
                allFormState: {},
                editingEntity: { ...EMPTY_COLLECTION_DETAIL_ENTITY },
                tableData: [],
                paymentModeHeader: { ...EMPTY_PAYMENT_MODE_ADDITIONAL_INFO_CRITERIA },
                isBankCode: false,
                isPayOrderNo: false,
                isPayOrderAmount: false,
                isCreditCardNo: false,
            },
            isShowPaymentModePanel: false,
        }))

        await repo.searchByCriteria(criteria).then(data =>
            counterCustomerChargeMainDispatch(prevState => ({
                ...prevState,
                tableData: data,
                isLoading: false,
            }))
        );
    }

    const searchAdditionalByCriteria = async (criteria: CounterCustomerChargeSearchCriteria) => {
        const data = await repo.searchAdditionalByCriteria(criteria);

        counterCustomerChargeMainDispatch(prevState => ({
            ...prevState,
            additionalState: {
                ...prevState.additionalState,
                tableData: data
            }
        }))
    }

    const onSearchAdditional = async (ids: number[]) => {
        const data = await repo.searchAdditionalByid(ids);

        counterCustomerChargeMainDispatch(prevState => ({
            ...prevState,
            additionalState: {
                ...prevState.additionalState,
                tableData: data
            }
        }))
    }

    const onSearchPaymentMode = async (id: number) => {
        const data = await repo.getCollectionDetailByHdrId(id);
        counterCustomerChargeMainDispatch(prevState => ({
            ...prevState,
            isShowPaymentModePanel: true,
            isShowAddPaymentModePanel: false,
            paymentModeState: {
                ...prevState.paymentModeState,
                tableData: data && data?.filter(item => item.id && item.id !== 0),
                paymentModeHeader: {
                    ...prevState.paymentModeState.paymentModeHeader,
                    invoiceAmount: data && data.length > 0 ? Math.round((data[0].totalInvAmt ?? 0) * 100) / 100 : null,
                    docHdrId: id,
                    draftInvoiceNo: data && data.length > 0 ? data[0].draftInvoiceNos ?? null : null,
                },
                allFormState: {},
                editingEntity: { ...EMPTY_COLLECTION_DETAIL_ENTITY },
                isAdd: false,
            }
        }))
    }

    const onSearchClick = async () => {
        counterCustomerChargeMainDispatch(prevState => ({
            ...prevState,
            isShowDetailPanel: true,
        }))
    }

    const updateSelectedRows = async (selecedRows: CounterCustomerChargeEntity[], operatingUnit: string, editWaiverList: number[], suppleWaiverList: number[]) => {
        let hasT = false;
        let hasMT = false;
        let hasH = false;
        let hasI = false;
        let hasMH = false;
        let hasSH = false;
        let hasDI = false;
        let hasSA = false;
        let hasW = false;
        let hasADRE = false;
        let isCanceled = false;
        let isAdjustment = false;
        // let isCancelAndRebill = false;
        let hasE = false;
        let hasF = false;
        let hasR = false;
        let hasC = false;
        let isWaiverIndEqulsY = false;
        let allowEditWaiver = true;
        let allowSuppleWaiver = true;
        let allowDoWaiver = true;
        let isEnabledEditWaiver = selecedRows.length === 0 ? false : true;
        let isEnabledSuppleWaiver = selecedRows.length === 0 ? false : true;
        let isEnabledWaiver = selecedRows.length === 0 ? false : true;
        let isEnabledChargeCom = selecedRows.length === 0 ? false : true;
        let isEnabledBillCom = selecedRows.length === 0 ? false : true;
        let isEnableExciseCashNo = selecedRows.length === 0 ? false : true;
        let isEnablePaidThroughDate = false;
        let isEnableAgentDeliveryDate = false;
        let isEnableExtensionPayment = false;
        let isNotCntrNO = false;
        let isEnableChargeQty = false;
        let isEnableExtraLabor = false;
        let isEnableAccTerminal = false;
        let isEnableHoldUnhold = false;
        let isDummyCntr = false;
        let newPreviousDateMap = new Map();
        let newExtensionPaymentMap = new Map();
        let disablePaidThroughDate = false;
        let isEnableMarkMT = selecedRows.length === 0 ? false : true;
        let isEnableDelete = selecedRows.length === 0 ? false : true;
        let isEnableAdjustment = selecedRows.length === 0 ? false : true;
        let isEnableCfsStuffing = selecedRows.length === 0 ? false : true;
        let isEnableImporiReHandling = true;
        let isEnablePreview = selecedRows.length === 0 ? false : true;

        let isAllowUptPaidThroughDate = selecedRows.length === 0 ? false : true;
        selecedRows.forEach(entity => {
            let isSuppleWaiver = false;
            let isEditWaiver = false;
            if (editWaiverList.some(item => item === entity.id)) {
                isEditWaiver = true;
            }
            if (suppleWaiverList.some(item => item === entity.id)) {
                isSuppleWaiver = true;
            }
            if (entity.dtlState === "I") {
                hasI = true;
            } else if (entity.dtlState === "T") {
                hasT = true;
            } else if (entity.dtlState === "MT") {
                hasMT = true;
            } else if (entity.dtlState === "SH") {
                hasSH = true;
            } else if (entity.dtlState === "MH") {
                hasMH = true;
            } else if (entity.dtlState === "H") {
                hasH = true;
            } else if (entity.dtlState === "DI") {
                hasDI = true;
            } else if (entity.dtlState === "SA") {
                hasSA = true;
            } else if (entity.dtlState === "W") {
                hasW = true;
            } else if (entity.dtlState === "C") {
                hasC = true;
            } else if (entity.dtlState === "E") {
                hasE = true;
            } else if (entity.dtlState === "F") {
                hasF = true;
            } else if (entity.dtlState === "R") {
                hasR = true;
            }

            if (entity.adjType === "Cancel Only") {
                isCanceled = true;
            } else if (entity.adjType === "Adjustment") {
                isAdjustment = true;
            } else if (entity.adjType === "Cancel & Re-bill") {
                // isCancelAndRebill = true;
                // } else if (entity.adjType === "Normal") {
                //     isEnableDelete = false;
            }
            // if (hasI) {
            //     isEnableAdjustment = true;
            // } else {
            //     isEnableAdjustment = false;
            // }
            if (entity.adreState === "AD" || entity.adreState === "RE") {
                hasADRE = true;
            }
            if (entity.waiverInd === "Y") {
                isWaiverIndEqulsY = true;
            }

            if (entity.chargeType === "CC" && (entity.subChargeType === "CI-XLAB" || entity.subChargeType === "CI-NPAL") && (hasT || hasR || hasF || hasE)) {
                isEnableExtraLabor = true;
            } else {
                isEnableExtraLabor = false;
            }

            if (entity.cntrNo && entity.cntrNo.indexOf("-") === 2) {
                isDummyCntr = true;
            }

            if (!entity.cntrNo) {
                isNotCntrNO = true;
            }

            if (operatingUnit === "SAPT" || operatingUnit === "KICT") {
                if (isAllowUptPaidThroughDate) {
                    if (entity.chargeType === "ITM" || (entity.chargeType === "CC" && entity.subChargeType === "ITM") ||
                        (entity.chargeType === "DEM" && entity.subChargeType === "DEI") ||
                        (entity.chargeType === "RFH" &&
                            (entity.subChargeType === "PCI" || entity.subChargeType === "PCIH" || entity.subChargeType === "FDC"))
                        || (entity.chargeType === "CSR" && (entity.subChargeType === "ST" || entity.subChargeType === "DE"))) {
                        if (entity.dtlState === "E" || entity.dtlState === "R" || entity.dtlState === "F") {
                            isAllowUptPaidThroughDate = true;
                        } else {
                            isAllowUptPaidThroughDate = false;
                        }
                    } else {
                        isAllowUptPaidThroughDate = false;
                    }
                }
            } else {
                if (isAllowUptPaidThroughDate) {
                    if ((entity.dtlState === "E" || entity.dtlState === "R" || entity.dtlState === "F" || (entity.dtlState === "T" && (operatingUnit === "OICT" || operatingUnit === "HPJZ")))
                        && !isCanceled && !isDummyCntr) {
                        isAllowUptPaidThroughDate = true;
                    } else {
                        isAllowUptPaidThroughDate = false;
                    }

                    if (hasI || hasC || hasSH || hasMH || hasDI || hasSA || hasH || hasW || hasADRE || isCanceled || isDummyCntr) {
                        isAllowUptPaidThroughDate = false;
                    }
                }
            }

            if (!(entity.dtlState === "W" && entity.waiverReasonCode
                && entity.waiverInitBy
                && !entity.waiverSubmitedBy
                && !entity.waiverApprovedBy
                && !isSuppleWaiver
                && allowEditWaiver)) {
                allowEditWaiver = false;
            }

            if (!((entity.dtlState === "R" || entity.dtlState === "F") && entity.waiverInd === "Y"
                && !isEditWaiver && allowSuppleWaiver)) {
                allowSuppleWaiver = false;
            }

            if (!((entity.dtlState === "R" || entity.dtlState === "F") && entity.waiverInd !== "Y"
                && allowDoWaiver)) {
                allowDoWaiver = false;
            }

            isEnabledEditWaiver = allowEditWaiver && entity.additionalChargeInd !== "Y";
            isEnabledSuppleWaiver = allowSuppleWaiver && entity.additionalChargeInd !== "Y";
            isEnabledWaiver = allowDoWaiver && entity.additionalChargeInd !== "Y";

            if (hasH || hasI || hasMH || hasMT || hasSH || hasT || hasDI || hasSA || hasW || hasADRE) {
                isEnabledChargeCom = false;
                isEnabledBillCom = false;
                isEnableExciseCashNo = false;
            }

            if ((entity.chargeType === "DOC" && entity.subChargeType === "CRO") ||
                (entity.chargeType === "CC" && entity.subChargeType === "WCERT" && entity.cntrNo) ||
                entity.chargeType === "NP_ODR") {
                if (!(isCanceled || hasI || hasC || hasSH || hasMH || hasDI || hasSA
                    || hasT || hasMT || hasH || hasW || isWaiverIndEqulsY)) {
                    isEnableChargeQty = true;
                }
            } else {
                isEnableChargeQty = false;
            }

            if (entity.cntrStatus1 === "IF" || entity.cntrStatus1 === "IM") {
                isEnableAgentDeliveryDate = true;
            }
        })
        if (!_.isEmpty(selecedRows) && selecedRows.every(ety => (ety.dtlState === "R" || ety.dtlState === "E" || ety.dtlState === "F" || ety.dtlState === "MT"))) {
            isEnableMarkMT = true;
        } else {
            isEnableMarkMT = false;
        }

        if (!_.isEmpty(selecedRows) && ((selecedRows.every(ety => ety.adjType !== "Normal" && !(ety.dtlState === "I" || ety.dtlState === "DI")))
            || (operatingUnit === "OICT" && selecedRows.every(ety => ety.adjType === "Normal" && "Y" === ety.isExtensionInd && "N" === ety.slabsChargeInd &&
                !(ety.dtlState === "I" || ety.dtlState === "DI"))))) {
            isEnableDelete = true;
        } else {
            isEnableDelete = false;
        }
        if (!_.isEmpty(selecedRows) && selecedRows.every(ety => (ety.adjType === "Normal" || ety.adjType === "Adjustment" || ety.adjType === "Cancel & Re-bill") && ety.dtlState === "I")) {
            isEnableAdjustment = true;
        } else {
            isEnableAdjustment = false;
        }

        if (operatingUnit === "OICT" || operatingUnit === "HPJZ") {
            disablePaidThroughDate = await repo.checkPaidThroughDate(selecedRows);
        }


        if (isAllowUptPaidThroughDate) {
            isEnablePaidThroughDate = true;
        } else {
            isEnablePaidThroughDate = false;
        }

        if (isWaiverIndEqulsY || isCanceled || hasI || hasC || hasSH || hasMH || hasDI || hasSA || hasADRE || ((hasT || hasMT) && hasH)) {
            /*isEnabledEditWaiver = false;
            isEnabledSuppleWaiver = false;
            isEnabledWaiver = false;
            isEnabledChargeCom = false;
            isEnabledBillCom = false;
            isEnableExciseCashNo = false;
            isEnableExtraLabor = false;*/
            if (isCanceled && !hasI && !hasC && !hasSH && !hasMH && !hasDI && !hasSA
                && !((hasT || hasMT) && hasH)) {
                isEnableAccTerminal = true;
                isEnableHoldUnhold = true;
            }
        } else {
            if (hasT || hasMT || hasH) {
                if (hasT || hasMT) {
                    isEnableAccTerminal = true;
                }
                if (hasH) {
                    isEnableHoldUnhold = true;
                }
            } else if (hasE || hasF || hasR) {
                if (isAdjustment || isCanceled) {
                    isEnableAccTerminal = true;
                    isEnableHoldUnhold = true;
                } else {
                    /*isEnabledEditWaiver = true;
                    isEnabledSuppleWaiver = true;
                    isEnabledWaiver = true;
                    isEnabledChargeCom = true;
                    isEnabledBillCom = true;
                    isEnableExciseCashNo = true;
                    isEnableExtraLabor = true;
                    isEnablePaidThroughDate = true;
                    isEnableChargeQty = true;
                    isEnableExtraLabor = true;*/
                    isEnableAccTerminal = true;
                    isEnableHoldUnhold = true;
                }
            }
        }

        if (hasI || hasDI || hasC || isCanceled || isDummyCntr || isNotCntrNO) {
            isEnableAgentDeliveryDate = false;
        }

        if (operatingUnit === "OICT" || operatingUnit === "HPJZ") {

            if (selecedRows && selecedRows.length > 0) {
                isEnableExtensionPayment = await repo.checkExtensionPayment(selecedRows);
                if (isEnableExtensionPayment) {
                    isEnablePaidThroughDate = false;
                }
                await repo.getPreviousDate(selecedRows).then(res => {
                    if (res && res.success && res.data) {
                        const extension: ExtensionPaymentCriteria[] = res.data;
                        extension.forEach(item => {
                            newExtensionPaymentMap.set(item.cntrNo, item.paidThroughDate);
                            newPreviousDateMap.set(item.cntrNo, item.previousDate);
                        });
                    }
                });
            }
        }

        if (disablePaidThroughDate) {
            isEnablePaidThroughDate = false;
        }

        counterCustomerChargeMainDispatch(prevState => {

            return {
                ...prevState,
                selectedRows: selecedRows,
                currentSelectedRow: selecedRows[0] ?? null,
                isEnabledEditWaiver: isEnabledEditWaiver,
                isEnabledSuppleWaiver: isEnabledSuppleWaiver,
                isEnabledWaiver: isEnabledWaiver,
                isEnabledChargeCom: isEnabledChargeCom,
                isEnabledBillCom: isEnabledBillCom,
                isEnableExciseCashNo: isEnableExciseCashNo,
                isEnablePaidThroughDate: isEnablePaidThroughDate,
                isEnableChargeQty: isEnableChargeQty,
                isEnableExtraLabor: isEnableExtraLabor,
                isEnableAccTerminal: isEnableAccTerminal,
                isEnableHoldUnhold: isEnableHoldUnhold,
                isEnableAgentDeliveryDate: isEnableAgentDeliveryDate,
                isEnableExtensionPayment: isEnableExtensionPayment,
                previousPaidThroughDateMap: newPreviousDateMap,
                extensionPaymentMap: newExtensionPaymentMap,
                isEnableMarkMT: isEnableMarkMT,
                isEnableDelete: isEnableDelete,
                isEnableAdjustment: isEnableAdjustment,
                isEnableCfsStuffing: isEnableCfsStuffing,
                isEnableImporiReHandling: isEnableImporiReHandling,
                isEnablePreview: isEnablePreview
            }
        })
    }

    const updateAdditionalSelectedRows = async (selecedRows: CounterCustomerChargeEntity[]) => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                additionalState: {
                    ...prevState.additionalState,
                    selectedRows: selecedRows,
                    currentSelectedRow: selecedRows[0] ?? null,
                },
            }
        })
    }

    const updateAdditionalVesselSelectedRows = async (selecedRows: AdditionChargeVesselEntity[]) => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                additionalState: {
                    ...prevState.additionalState,
                    currentSelectedVesselRow: selecedRows[0] ?? null,
                },
            }
        })
    }

    const onAdd = (currentEntity: CounterCustomerChargeEntity) => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                isShowAdditionalChargePanel: true,
                isShowBillToCompanyPanel: false,
                isShowChargeOnCompanyPanel: false,
                isShowInvoiceInfoPanel: false,
                isShowWaiverReasonCodePanel: false,
                isShowPaidThroughDatePanel: false,
                isShowSuppleWaiverPanel: false,
                isShowAdjustmentPanel: false,
                isShowChargeQtyPanel: false,
                isShowExtraLaborPanel: false,
                isShowAccTerminalPanel: false,
                isShowStuffingPanel: false,
                additionalState: {
                    ...prevState.additionalState,
                    isAdd: true,
                    isEditable: false,
                    isRead: false,
                    editingEntity: {
                        ...EMPTY_COUNTER_CUSTOMER_CHARGE_ENTITY,
                        billOfLading: currentEntity?.billOfLading ?? null,
                        shippingBill: currentEntity?.shippingBill ?? null,
                        owner1: currentEntity?.owner1 ?? null,
                        opsDate: currentEntity?.opsDate ?? null,
                        serviceCode: currentEntity?.serviceCode ?? null,
                        arrDateTime: currentEntity?.arrDateTime ?? null,
                        etd: currentEntity?.etd ?? null,
                        agentNo: currentEntity?.agentNo ?? null,
                        chargeOnCompany: currentEntity?.chargeOnCompany ?? null,
                        billToCompany: currentEntity?.billToCompany ?? null,
                        forwarderReference: currentEntity?.forwarderReference ?? null,
                        counterCustCompCode: currentEntity?.counterCustCompCode ?? null,
                        consortiumCode: currentEntity?.consortiumCode ?? null,
                        vesselCode: currentEntity?.vesselCode ?? null,
                        voyageCode: currentEntity?.voyageCode ?? null,
                        vesselName: currentEntity?.vesselName ?? null,
                        poo: currentEntity?.poo ?? null,
                        pod1: currentEntity?.pod1 ?? null,
                        pol: currentEntity?.pol ?? null,
                        fd: currentEntity?.fd ?? null,
                    },
                    tableData: [],
                    isShowEditPanel: false,
                    currentSelectedRow: EMPTY_COUNTER_CUSTOMER_CHARGE_ENTITY,
                }
            }
        })
    }

    const onAdditionalAdd = () => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                isShowAdditionalChargePanel: true,
                additionalState: {
                    ...prevState.additionalState,
                    isAdd: true,
                    isEditable: false,
                    isRead: false,
                    editingEntity: {
                        ...EMPTY_COUNTER_CUSTOMER_CHARGE_ENTITY,
                        billOfLading: prevState.additionalState.editingEntity.billOfLading,
                        shippingBill: prevState.additionalState.editingEntity.shippingBill,
                        opsDate: prevState.additionalState.editingEntity.opsDate,
                        owner1: prevState.additionalState.editingEntity.owner1,
                        serviceCode: prevState.additionalState.editingEntity.serviceCode,
                        arrDateTime: prevState.additionalState.editingEntity.arrDateTime,
                        etd: prevState.additionalState.editingEntity.etd,
                        agentNo: prevState.additionalState.editingEntity.agentNo,
                        chargeOnCompany: prevState.additionalState.editingEntity.chargeOnCompany,
                        billToCompany: prevState.additionalState.editingEntity.billToCompany,
                        counterCustCompCode: prevState.additionalState.editingEntity.counterCustCompCode,
                        consortiumCode: prevState.additionalState.editingEntity.consortiumCode,
                        vesselCode: prevState.additionalState.editingEntity.vesselCode,
                        voyageCode: prevState.additionalState.editingEntity.voyageCode,
                        vesselName: prevState.additionalState.editingEntity.vesselName,
                        poo: prevState.additionalState.editingEntity.poo,
                        pod1: prevState.additionalState.editingEntity.pod1,
                        pol: prevState.additionalState.editingEntity.pol,
                        fd: prevState.additionalState.editingEntity.fd,
                    },
                    isShowEditPanel: true,
                }
            }
        })
    }

    const onAdditionalEdit = (editingEntity: CounterCustomerChargeEntity) => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                isShowAdditionalChargePanel: true,
                additionalState: {
                    ...prevState.additionalState,
                    isAdd: false,
                    isEditable: true,
                    isRead: false,
                    editingEntity: {
                        ...prevState.additionalState.editingEntity,
                        id: editingEntity.id,
                        chargeType: editingEntity.chargeType,
                        subChargeType: editingEntity.subChargeType,
                        cntrNo: editingEntity.cntrNo,
                        cntrType: editingEntity.cntrType,
                        cntrSize: editingEntity.cntrSize,
                        cntrStatus1: editingEntity.cntrStatus1,
                        chargeQty: editingEntity.chargeQty,
                        chargeQtyUom: editingEntity.chargeQtyUom,
                        tariffType: editingEntity.tariffType,
                        tariffCode: editingEntity.tariffCode,
                        fromDate: editingEntity.fromDate,
                        toDate: editingEntity.toDate,
                        gateInDate: editingEntity.gateInDate,
                        pcPlugOnDatetime: editingEntity.pcPlugOnDatetime,
                        pcPlugOffDatetime: editingEntity.pcPlugOffDatetime,
                        dgSurchargeInd: editingEntity.dgSurchargeInd,
                        oogSurchargeInd: editingEntity.oogSurchargeInd,
                    },
                    isShowEditPanel: true,
                }
            }
        })
    }


    const onEdit = (currentEntity: CounterCustomerChargeEntity) => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                currentSelectedRow: currentEntity,
                isShowEditPanel: true,
                masterState: {
                    ...prevState.masterState,
                    isAdd: false,
                    isEditable: false,
                    isRead: true,
                    editingEntity: {
                        ...currentEntity
                    },
                }
            }
        })
    }

    const onEditClick = (currentEntity: CounterCustomerChargeEntity) => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                currentSelectedRow: currentEntity,
                isShowEditPanel: true,
                masterState: {
                    ...prevState.masterState,
                    isAdd: false,
                    isEditable: true,
                    isRead: currentEntity.masterType === 'Country Code',
                    editingEntity: {
                        ...currentEntity
                    },
                }
            }
        })
    }

    const onReset = () => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: { ...EMPTY_COUNTER_CUSTOMER_CHARGE_SEARCH_CRITERIA }
            }
        })
    }

    const onClose = () => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                currentSelectedRow: EMPTY_COUNTER_CUSTOMER_CHARGE_ENTITY,
                selectedRows: [],
                isShowDetailPanel: false,
                isShowAdditionalChargePanel: false,
            }
        })
    }

    const onSerachPanl = () => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                isShowDetailPanel: false,
                isShowAdditionalChargePanel: false,
                isShowSerachClose: true,
            }
        })
    }

    const onSerachPanlClose = () => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                isShowDetailPanel: true,
                isShowSerachClose: false,
            }
        })
    }

    const onMoreClose = () => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                isShowBillToCompanyPanel: false,
                isShowChargeOnCompanyPanel: false,
                isShowInvoiceInfoPanel: false,
                isShowPaidThroughDatePanel: false,
                isShowWaiverReasonCodePanel: false,
                isShowSuppleWaiverPanel: false,
                isShowAdjustmentPanel: false,
                isShowChargeQtyPanel: false,
                isShowExtraLaborPanel: false,
                isShowAccTerminalPanel: false,
                isShowStuffingPanel: false,
                isShowAgentDeliveryDatePanel: false,
                isShowExtensionPaymentPanel: false,
                editingEntity: { ...EMPTY_COUNTER_CUSTOMER_CHARGE_ENTITY },
                allFormState: {},
                paidThroughDateMap: new Map(),
                agentDeliveryDateMap: new Map(),
                extensionPaymentMap: new Map(),
                selectedPaidThroughDateMap: new Map(),
                selectedAgentDeliveryDateMap: new Map(),
            }
        })
    }

    const onAdditionalClose = () => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                additionalState: {
                    ...prevState.additionalState,
                    currentSelectedRow: EMPTY_COUNTER_CUSTOMER_CHARGE_ENTITY,
                    isShowEditPanel: false,
                    tableData: [],
                    editingEntity: EMPTY_COUNTER_CUSTOMER_CHARGE_ENTITY,
                    allFormState: {},
                    selectedRows: [],
                },
                isShowAdditionalChargePanel: false,

            }
        })
    }

    const onAdditionalEditClose = () => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                additionalState: {
                    ...prevState.additionalState,
                    isShowEditPanel: false,
                    allFormState: {},
                    editingEntity: {
                        ...prevState.additionalState.editingEntity,
                        chargeType: null,
                        subChargeType: null,
                        tariffCode: null,
                        tariffType: null,
                        chargeQty: null,
                        chargeQtyUom: null,
                        cntrNo: null,
                        cntrSize: null,
                        cntrType: null,
                        cntrStatus1: null,
                        fromDate: null,
                        toDate: null,
                        gateInDate: null,
                        pcPlugOnDatetime: null,
                        pcPlugOffDatetime: null,
                    }
                },
            }
        })
    }

    const onSaveAdditionalClicked = async () => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                additionalState: {
                    ...prevState.additionalState,
                    isSaveClicked: true,
                    allFormState: {},
                }
            }
        });
    }
    const onSaveAdditionalEdit = async (currentEntity: CounterCustomerChargeEntity,) => {
        let validatedResult: { [x: string]: string } = {};
        let isSaveSuccess = false;
        let message: string = '';

        const valResult = await Validation(createAdditionalChargeValidationSchema).ValidateFormOnly(currentEntity);
        if (valResult) {
            validatedResult = { ...valResult };
        }
        if (currentEntity.cntrNo) {
            const valCntrResult = await Validation(createCntrAdditionalChargeValidationSchema).ValidateFormOnly(currentEntity);
            if (valCntrResult) {
                validatedResult = { ...validatedResult, ...valCntrResult };
            }
        }
        if (currentEntity.chargeQtyUom && currentEntity.chargeQtyUom === 'DAY') {
            const valUomResult = await Validation(createUomAdditionalChargeValidationSchema).ValidateFormOnly(currentEntity);
            if (valUomResult) {
                validatedResult = { ...validatedResult, ...valUomResult };
            }
        }
        if (Object.keys(validatedResult).length !== 0) {
            // validatedResult = { ...valResult };

            counterCustomerChargeMainDispatch(prevState => {
                return {
                    ...prevState,
                    additionalState: {
                        ...prevState.additionalState,
                        forceRefresh: !prevState.additionalState.forceRefresh,
                        isSaveClicked: true,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });

            /*const res: ResponseEntity = {
                code: "",
                success: false,
                msg: null,
                data: null
            }

            return res;*/
        } else {
            let editingEntity: CounterCustomerChargeEntity = currentEntity;
            counterCustomerChargeMainDispatch(prevState => {
                editingEntity = {
                    ...prevState.additionalState.editingEntity,
                    chargeType: currentEntity.chargeType,
                    subChargeType: currentEntity.subChargeType,
                    tariffCode: currentEntity.tariffCode,
                    tariffType: currentEntity.tariffType,
                    chargeQty: currentEntity.chargeQty,
                    chargeQtyUom: currentEntity.chargeQtyUom,
                    cntrNo: currentEntity.cntrNo,
                    cntrSize: currentEntity.cntrSize,
                    cntrType: currentEntity.cntrType,
                    cntrStatus1: currentEntity.cntrStatus1,
                    fromDate: currentEntity.fromDate,
                    toDate: currentEntity.toDate,
                    gateInDate: currentEntity.gateInDate,
                    pcPlugOnDatetime: currentEntity.pcPlugOnDatetime,
                    pcPlugOffDatetime: currentEntity.pcPlugOffDatetime,
                }
                if ((!_.isEmpty(editingEntity.billOfLading) && !_.isEmpty(editingEntity.shippingBill)) || (_.isEmpty(editingEntity.billOfLading) && _.isEmpty(editingEntity.shippingBill))) {
                    message = 'Please input either one of Bill of Lading / Ref. No. or Shipping Bill.';
                }
                /*if (!_.isEmpty(editingEntity.counterCustCompCode) && editingEntity.counterCustCompCode !== 'Shipper' && editingEntity.counterCustCompCode !== 'Consignee' && editingEntity.counterCustCompCode !== 'Both') {
                    message = 'Invalid Shipper / Consignee.';
                }*/
                if (editingEntity.fromDate !== null && editingEntity.toDate !== null && editingEntity.fromDate > editingEntity.toDate) {
                    message = '"To" date should be later than "From" date.';
                }
                if (editingEntity.pcPlugOnDatetime !== null && editingEntity.pcPlugOffDatetime !== null && editingEntity.pcPlugOnDatetime > editingEntity.pcPlugOffDatetime) {
                    message = '"Power Plug Off  Datetime" should be later than "Power Plug On Datetime" .';
                }
                // if (!_.isEmpty(editingEntity.cntrNo)) {
                //     if (!editingEntity.cntrSize) {
                //         message = 'Size is mandatory.';
                //     }
                //     if (!editingEntity.cntrType) {
                //         message = 'Type is mandatory.';
                //     }
                //     if (!editingEntity.cntrStatus1) {
                //         message = 'Status is mandatory.';
                //     }
                // }
                // if (editingEntity.chargeQtyUom === "DAY") {
                //     if (!editingEntity.fromDate) {
                //         message = 'From is mandatory.';
                //     }
                //     if (!editingEntity.toDate) {
                //         message = 'To is mandatory.';
                //     }
                // }

                return {
                    ...prevState,
                    additionalState: {
                        ...prevState.additionalState,
                        allFormState: {},
                        editingEntity: editingEntity,
                        //isShowEditPanel: false,
                    }
                }
            });

            if (message === '') {
                const res = await repo.updateAdditional(editingEntity);
                if (res && res.success && res.data) {
                    const data = res.data;
                    counterCustomerChargeMainDispatch(prevState => {
                        const filteredData = prevState.additionalState.tableData?.filter(item => data.id !== item.id);

                        return {
                            ...prevState,
                            additionalState: {
                                ...prevState.additionalState,
                                tableData: [...(filteredData || []), data]
                            }
                        }
                    });

                    isSaveSuccess = true;
                    onAdditionalEditClose();
                } else {
                    message = res?.data ?? 'Faild to save additional charge.'
                }
            }
        }

        const res: ResponseEntity = {
            code: "",
            success: isSaveSuccess,
            msg: null,
            data: message
        }

        return res;
    }

    const onSave = async (currentEntity: CounterCustomerChargeEntity[]) => {
        /*if (currentEntity && currentEntity.some(entity => !entity.agentDeliveryDate)) {
            counterCustomerChargeMainDispatch(prevState => {
                return {
                    ...prevState,
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...prevState.masterState.allFormState,
                            agentDeliveryDate: 'Missing.'
                        },
                    }
                }
            })
        }
        if (currentEntity && currentEntity.some(entity => !entity.paidThroughDate)) {
            counterCustomerChargeMainDispatch(prevState => {
                return {
                    ...prevState,
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...prevState.masterState.allFormState,
                            paidThroughDate: 'Missing.'
                        },
                    }
                }
            })
        }*/
        return await repo.updateEntity(currentEntity);
    }

    const updatePaidThroughDate = async (updatedData: Map<string, Date>) => {
        return await repo.updatePaidThroughDate(updatedData);
    }

    const updateExtensionPayment = async (updatedData: Map<string, CounterCustomerChargeEntity>) => {
        return await repo.updateExtensionPayment(updatedData);
    }

    const onCheckboxChange = (checked: boolean, fieldName: string) => {
        counterCustomerChargeMainDispatch(prevState => ({
            ...prevState,
            additionalState: {
                ...prevState.additionalState,
                editingEntity: {
                    ...prevState.additionalState.editingEntity,
                    [fieldName]: checked ? "Y" : "N",
                }
            }
        }))
    }

    const onFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                additionalState: {
                    ...prevState.additionalState,
                    editingEntity: {
                        ...prevState.additionalState.editingEntity,
                        [fieldKey]: val,
                    },
                    allFormState: {
                        ...prevState.additionalState.allFormState,
                        [fieldKey]: ''
                    },
                }
            }
        })
    }
    const onDateRangeChange = (startDate: any, endDate: any, dateFields: { startField: string, endField: string }) => {
        counterCustomerChargeMainDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [dateFields.startField]: startDate,
                [dateFields.endField]: endDate,
            }
        }))
    }

    const onDropdownChange = (e: any, fieldName: string) => {
        counterCustomerChargeMainDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [fieldName]: e?.value ?? (_.isEmpty(e) ?
                    (fieldName === "subChgTypeList" ? [] : '') : e),
            }
        }))
    }

    const onCoVslVoyChange = (inputData: { co?: string, vsl?: string, voy?: string }, fieldName: { co: string, vsl: string, voy: string }) => {
        counterCustomerChargeMainDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [fieldName.co]: inputData?.co?.toUpperCase().replace(/\s+/g, ''),
                [fieldName.vsl]: inputData?.vsl?.toUpperCase().replace(/\s+/g, ''),
                [fieldName.voy]: inputData?.voy?.toUpperCase().replace(/\s+/g, ''),
            }
        }))
    }

    const onCoVslVoyVelChange = (inputData: { co?: string, vsl?: string, voy?: string, vel?: string }, fieldName: { co: string, vsl: string, voy: string, vel: string }) => {
        counterCustomerChargeMainDispatch(prevState => ({
            ...prevState,
            additionalState: {
                ...prevState.additionalState,
                editingEntity: {
                    ...prevState.additionalState.editingEntity,
                    [fieldName.co]: inputData?.co?.toUpperCase().replace(/\s+/g, ''),
                    [fieldName.vsl]: inputData?.vsl?.toUpperCase().replace(/\s+/g, ''),
                    [fieldName.voy]: inputData?.voy?.toUpperCase().replace(/\s+/g, ''),
                    [fieldName.vel]: inputData?.vel?.replace(/\s+/g, ''),
                }
            },
        }))
    }

    const onTextAreaChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue?.toString().toUpperCase();
        const cntrNoArray = val?.split('\n');

        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: {
                    ...prevState.searchCriteria,
                    [fieldKey]: fieldKey === 'cntrList' ? cntrNoArray/*val.split(',').map((item: string) => item.trim())*/ : val,
                }
            }
        })
    }

    const onTextAreaChangeCC = (e: ChangeEvent<HTMLTextAreaElement>, fieldName: string, toUpperCase: boolean = false) => {
        counterCustomerChargeMainDispatch(prevState => ({
            ...prevState,
            editingEntity: {
                ...prevState.editingEntity,
                [fieldName]: e.target.value.toString(),
            }
        }))
    };

    const onHeaderFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                currentSelectedRow: {
                    ...prevState.currentSelectedRow,
                    [fieldKey]: val,
                },
            }
        })
    }

    const onAdditionalFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }
        if (fieldKey === 'cntrNo' || fieldKey === 'poo' || fieldKey === 'pod1' || fieldKey === 'pol' || fieldKey === 'fd' || fieldKey === 'shippingBill' || fieldKey === 'billOfLading') {
            val = val.toUpperCase().replace(/\s+/g, '')
        }
        if (fieldKey === 'chargeQtyUom') {
            counterCustomerChargeMainDispatch(prevState => {
                return {
                    ...prevState,
                    additionalState: {
                        ...prevState.additionalState,
                        forceRefresh: !prevState.additionalState.forceRefresh,
                        editingEntity: {
                            ...prevState.additionalState.editingEntity,
                            [fieldKey]: val,
                        },
                        allFormState: {
                            ...prevState.additionalState.allFormState,
                            [fieldKey]: '',
                            fromDate: '',
                            toDate: '',
                        },
                    }
                }
            })
        } else {
            counterCustomerChargeMainDispatch(prevState => {
                let tariffCode = prevState.additionalState.editingEntity.tariffCode;
                let subChargeType = prevState.additionalState.editingEntity.subChargeType;
                if (fieldKey === 'tariffType') {
                    tariffCode = null;
                } else if (fieldKey === 'tariffCode') {
                    tariffCode = val;
                }
                if (fieldKey === 'chargeType') {
                    subChargeType = null;
                } else if (fieldKey === 'subChargeType') {
                    subChargeType = val;
                }
                return {
                    ...prevState,
                    additionalState: {
                        ...prevState.additionalState,
                        forceRefresh: !prevState.additionalState.forceRefresh,
                        editingEntity: {
                            ...prevState.additionalState.editingEntity,
                            [fieldKey]: val,
                            tariffCode: tariffCode,
                            subChargeType: subChargeType,
                        },
                        allFormState: {
                            ...prevState.additionalState.allFormState,
                            [fieldKey]: ''
                        },
                    }
                }
            })
        }
    }

    const onCounterCustomerFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        counterCustomerChargeMainDispatch(prevState => {
            const newPaidThroughDateMap = new Map(prevState.paidThroughDateMap);
            // if (operatingUnit !== "RSCT" && newPaidThroughDateMap.has(fieldKey)) {
            //     newPaidThroughDateMap.set(fieldKey, val);
            // }
            const newAgentDeliveryDateMap = new Map(prevState.agentDeliveryDateMap);
            if (newAgentDeliveryDateMap.has(fieldKey)) {
                newAgentDeliveryDateMap.set(fieldKey, val);
            }
            const newExtensionPaymentMap = new Map(prevState.extensionPaymentMap);
            if (newExtensionPaymentMap.has(fieldKey)) {
                newExtensionPaymentMap.set(fieldKey, val);
            }
            return {
                ...prevState,
                editingEntity: {
                    ...prevState.editingEntity,
                    [fieldKey]: val,
                },
                masterState: {
                    ...prevState.masterState,
                    allFormState: {
                        ...prevState.masterState.allFormState,
                        [fieldKey]: ''
                    },
                },
                paidThroughDateMap: newPaidThroughDateMap,
                agentDeliveryDateMap: newAgentDeliveryDateMap,
                extensionPaymentMap: newExtensionPaymentMap,
                allFormState: {
                    ...prevState.allFormState,
                    [fieldKey]: ''
                },
            }
        })
    }

    const onApplyAll = async (ids: number[]) => {
        return await repo.applyAll(ids);
    }

    const onApplyAdditional = async (counterCusts: CounterCustomerChargeEntity[]) => {
        return await repo.applyAdditional(counterCusts);
    }

    const onConfirmAndSubmit = async (criteria: CounterCustomerChargeSearchCriteria, operatingUnit: string) => {
        return await repo.confirmAndSubmit(criteria);
    }

    const setDocHdrId = async (id: number) => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                paymentModeState: {
                    ...prevState.paymentModeState,
                    paymentModeHeader: {
                        ...prevState.paymentModeState.paymentModeHeader,
                        docHdrId: id,
                    }

                }
            }
        })
    }

    const onDeleteClick = () => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                additionalState: {
                    ...prevState.additionalState,
                    isShowDeleteModal: true
                }
            }
        })
    }

    const onDeleteAdditional = async (ids: number[]) => {
        return await repo.deleteAdditional(ids).then(res => {
            if (res && res.success) {
                counterCustomerChargeMainDispatch(prevState => {
                    if (!Array.isArray(ids) || ids.length === 0) {
                        return prevState;
                    }

                    const idSet = new Set(ids);
                    const filteredData = prevState.additionalState.tableData?.filter(item => !idSet.has(item.id));

                    return {
                        ...prevState,
                        additionalState: {
                            ...prevState.additionalState,
                            tableData: filteredData,
                            isShowDeleteModal: false,
                            selectedRows: []
                        }
                    }
                })
            }

            return res;
        });
    }

    const onCancelDelete = () => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                additionalState: {
                    ...prevState.additionalState,
                    isShowDeleteModal: false
                }
            }
        })
    }

    const onMarkMT = async (ids: number[]) => {
        return await repo.markMT(ids);
    }

    const previewDocReport = async (draftDocNos: string[]) => {

        await repo.previewDocReport(draftDocNos).then((data) => {
            prevOrDownloadRpt(data, false);
        }).catch((error) => {
            counterCustomerChargeMainDispatch(prevState => {
                return {
                    ...prevState,
                    allFormState: { "previewDocReport": "preview document report error." }
                }
            })
        })
    }

    const prevOrDownloadRpt = (data: any, isDownloadRpt: boolean) => {
        if (data != null) {
            for (const key in data) {

                if (data[key] != null && data[key] !== undefined) {
                    const tempData = data[key] as string;

                    let base64 = tempData
                    let bstr = atob(base64)
                    let n = bstr.length
                    let u8arr = new Uint8Array(n)
                    while (n--) {
                        u8arr[n] = bstr.charCodeAt(n)
                    }
                    const blob = new Blob([u8arr], { type: 'application/pdf' });
                    const url = URL.createObjectURL(blob);

                    if (isDownloadRpt) {
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = key + ".pdf";
                        a.style.display = 'none';
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                        document.body.removeChild(a);
                    } else {
                        window.open(url, '_blank');
                        //URL.revokeObjectURL(url);
                    }
                }
            };

            return true;
        }

        return false;
    }

    const onMore = async (name: string, rows: CounterCustomerChargeEntity[]) => {
        let billToCompany: boolean = false;
        let chargeOnCompany: boolean = false;
        let invoiceInfo: boolean = false;
        let paidThroughDate: boolean = false;
        let waiverReasonCode: boolean = false;
        let suppleWaiver: boolean = false;
        let adjustment: boolean = false;
        let chargeQty: boolean = false;
        let extraLabor: boolean = false;
        let accTerminal: boolean = false;
        let stuffing: boolean = false;
        let agentDeliveryDate: boolean = false;
        let extensionPayment: boolean = false;
        if (name === "BillToCompany") {
            billToCompany = true;
        } else if (name === "ChargeOnCompany") {
            chargeOnCompany = true;
        } else if (name === "InvoiceInfo") {
            invoiceInfo = true;
        } else if (name === "PaidThroughDate") {
            paidThroughDate = true;
        } else if (name === "WaiverReasonCode") {
            waiverReasonCode = true;
        } else if (name === "SuppleWaiver") {
            suppleWaiver = true;
        } else if (name === "Adjustment") {
            adjustment = true;
        } else if (name === "ChargeQty") {
            chargeQty = true;
        } else if (name === "ExtraLabor") {
            extraLabor = true;
        } else if (name === "AccTerminal") {
            accTerminal = true;
        } else if (name === "Stuffing") {
            stuffing = true;
        } else if (name === "AgentDeliveryDate") {
            agentDeliveryDate = true;
        } else if (name === "ExtensionPayment") {
            extensionPayment = true;
        }
        let newPaidThroughDateMap = new Map();
        if (paidThroughDate) {
            const data = await repo.getPaidThroughDateForFSP(rows);
            if (data && data !== undefined) {
                for (const key in data) {
                    newPaidThroughDateMap.set(key, data[key]);
                }
            }
        }

        counterCustomerChargeMainDispatch(prevState => {
            let editingEntity = prevState.currentSelectedRow;
            let { selectedRows } = prevState;
            const newExtensionPaymentMap = new Map();
            const newAgentDeliveryDateMap = new Map();
            const newDate = new Date();
            newDate.setHours(23, 59, 59, 0);
            if (paidThroughDate) {
                if (!editingEntity.paidThroughDate) {
                    editingEntity = {
                        ...editingEntity,
                        paidThroughDate: newDate,
                    }
                }
                selectedRows.forEach(row => {
                    if (row.cntrNo && !newPaidThroughDateMap.has(row.cntrNo)) {
                        newPaidThroughDateMap.set(row.cntrNo, row.paidThroughDate ? row.paidThroughDate : newDate);
                    }
                })
            }
            if (agentDeliveryDate) {
                selectedRows.forEach(row => {
                    if (row.cntrNo && !newAgentDeliveryDateMap.has(row.cntrNo)) {
                        newAgentDeliveryDateMap.set(row.cntrNo, row.agentDeliveryDate);
                    }
                })
            }
            if (extensionPayment) {
                selectedRows.forEach(row => {
                    if (row.cntrNo && !newExtensionPaymentMap.has(row.cntrNo)) {
                        newExtensionPaymentMap.set(row.cntrNo, row.paidThroughDate);
                    }
                })
            }
            if (adjustment) {
                editingEntity = {
                    ...editingEntity,
                    adjustmentType: AdjustmentTypePolicy.TEXT_CANCEL,
                }
            }
            if (stuffing) {
                if (editingEntity?.cfsBy === "T") {
                    editingEntity = {
                        ...editingEntity,
                        cfsBy: "CFS by Terminal",
                    }
                } else if (editingEntity?.cfsBy === "C") {
                    editingEntity = {
                        ...editingEntity,
                        cfsBy: "CFS by Customer",
                    }
                } else {
                    editingEntity = {
                        ...editingEntity,
                        cfsBy: "N/A",
                    }
                }

            }
            return {
                ...prevState,
                editingEntity: editingEntity,
                isShowBillToCompanyPanel: billToCompany,
                isShowChargeOnCompanyPanel: chargeOnCompany,
                isShowInvoiceInfoPanel: invoiceInfo,
                isShowPaidThroughDatePanel: paidThroughDate,
                isShowWaiverReasonCodePanel: waiverReasonCode,
                isShowSuppleWaiverPanel: suppleWaiver,
                isShowAdjustmentPanel: adjustment,
                isShowChargeQtyPanel: chargeQty,
                isShowExtraLaborPanel: extraLabor,
                isShowAccTerminalPanel: accTerminal,
                isShowStuffingPanel: stuffing,
                isShowAgentDeliveryDatePanel: agentDeliveryDate,
                isShowExtensionPaymentPanel: extensionPayment,
                paidThroughDateMap: newPaidThroughDateMap,
                agentDeliveryDateMap: newAgentDeliveryDateMap,
                allFormState: {},
                extensionPaymentMap: newExtensionPaymentMap,
            }
        })
    }

    const onEditWaiver = async (ids: number[]) => {
        return await repo.editWaiver(ids);
    }

    const onSuppleWaiver = async (currentEntity: CounterCustomerChargeEntity[]) => {
        return await repo.suppleWaiver(currentEntity);
    }

    const onDelete = (ids: number[]) => {
        let chargeDetails: ChargeDetailEntity[] = [];
        ids.forEach(id => {
            chargeDetails.push({ ...EMPTY_CHARGE_DETAIL_ENTITY, key: id.toString() });
        });
        return chargeDetail.deleteCharge(chargeDetails);
    }

    const onAdjustment = async (currentEntity: CounterCustomerChargeEntity[]) => {
        return await repo.adjustment(currentEntity);
    }

    const onCheckAdjustment = async (currentEntity: CounterCustomerChargeEntity[]) => {
        return await repo.checkAdjustment(currentEntity);
    }


    const onShowPanel = (editingEntity: CounterCustomerChargeEntity) => {
        repo.searchVesselInfo(editingEntity).then((data) => {
            counterCustomerChargeMainDispatch(prevState => {
                return {
                    ...prevState,
                    isShowFindVesselPanel: true,
                    additionalState: {
                        ...prevState.additionalState,
                        vesselTableData: data,
                    }
                }
            })
        })
    }

    const closeCompDialog = () => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                isShowFindVesselPanel: false,
                additionalState: {
                    ...prevState.additionalState,
                    vesselTableData: [],
                }
            }
        })
    }

    const closeCompDialogForPayment = (id: number | null) => {
        let searchCriteria: CounterCustomerChargeSearchCriteria = { ...EMPTY_COUNTER_CUSTOMER_CHARGE_SEARCH_CRITERIA };
        counterCustomerChargeMainDispatch(prevState => {
            searchCriteria = prevState.searchCriteria;
            return {
                ...prevState,
                isShowPaymentModePanel: false,
                paymentModeState: {
                    ...prevState.paymentModeState,
                    tableData: [],
                    servicePayAmount: 0,
                    allFormState: {},
                    editingEntity: { ...EMPTY_COLLECTION_DETAIL_ENTITY },
                    isAdd: false,
                }
            }
        })
        if (id) {
            let ids: number[] = [];
            ids.push(id);
            repo.reject(ids).then(() => {
                onSearchCounterCustomer(searchCriteria)
            });
        }

    }

    const onResetForPayment = () => {
        counterCustomerChargeMainDispatch(prevState => {
            const letPaymentModeHeader = prevState.paymentModeState.paymentModeHeader;
            return {
                ...prevState,
                paymentModeState: {
                    ...prevState.paymentModeState,
                    paymentModeHeader: {
                        ...EMPTY_PAYMENT_MODE_ADDITIONAL_INFO_CRITERIA,
                        invoiceAmount: letPaymentModeHeader.invoiceAmount,
                        docHdrId: letPaymentModeHeader.docHdrId,
                        draftInvoiceNo: letPaymentModeHeader.draftInvoiceNo
                    },
                    allFormState: {},
                }
            }
        })
    }

    const applyVessel = async (row: AdditionChargeVesselEntity) => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                isShowFindVesselPanel: false,
                additionalState: {
                    ...prevState.additionalState,
                    vesselTableData: [],
                    editingEntity: {
                        ...prevState.additionalState.editingEntity,
                        consortiumCode: row.consortiumCode,
                        vesselCode: row.vesselCode,
                        voyageCode: row.voyageCode,
                        vesselName: row.vesselName,
                        etd: row.etd,
                        arrDateTime: row.etb,
                    },
                },
            }
        })
    }

    const onSearchFieldChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }
        return counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: {
                    ...prevState.searchCriteria,
                    [fieldKey]: val,
                },
            }
        });
    }

    const onPaymentModeAdd = () => {
        counterCustomerChargeMainDispatch(prevState => {
            //return (Math.round(a * factor) + Math.round(b * factor)) / factor;
            let paymentAmount = Math.round((prevState.paymentModeState.paymentModeHeader.invoiceAmount ?? 0) * 100);
            if (prevState.paymentModeState.tableData) {
                prevState.paymentModeState.tableData.forEach(item => {
                    paymentAmount = paymentAmount - Math.round((item.paymentAmount ?? 0) * 100);
                })
            }
            return {
                ...prevState,
                isShowAddPaymentModePanel: true,
                paymentModeState: {
                    ...prevState.paymentModeState,
                    isAdd: true,
                    editingEntity: {
                        ...EMPTY_COLLECTION_DETAIL_ENTITY,
                        paymentAmount: paymentAmount / 100,
                        paymentMode: PaymentModePolicy().getModeItemDroOptsForOICT()[1].value,
                    },
                    isBankCode: false,
                    isPayOrderNo: false,
                    isPayOrderAmount: false,
                    isCreditCardNo: false,
                }
            }
        })
    }

    const onPaymentModeAddClose = () => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                isShowAddPaymentModePanel: false,
                paymentModeState: {
                    ...prevState.paymentModeState,
                    allFormState: {},
                    editingEntity: { ...EMPTY_COLLECTION_DETAIL_ENTITY },
                    isAdd: false,
                },

            }
        })
    }

    const onPaymentModeAddSave = async (editingEntity: CollectionDetailEntity) => {
        let valResult = await Validation(createPaymentModeForPoValidationSchema).ValidateFormOnly(editingEntity);
        if (editingEntity.paymentMode && editingEntity.paymentMode === "CASH") {
            valResult = await Validation(createPaymentModeForCashValidationSchema).ValidateFormOnly(editingEntity);
        } else if (editingEntity.paymentMode && editingEntity.paymentMode === "PO") {
            valResult = await Validation(createPaymentModeForPoValidationSchema).ValidateFormOnly(editingEntity);
        } else if (editingEntity.paymentMode && editingEntity.paymentMode === "ONLINE_PAYMENT") {
            valResult = await Validation(createPaymentModeForOnlineValidationSchema).ValidateFormOnly(editingEntity);
        } else {
            valResult = await Validation(createPaymentModeForPosValidationSchema).ValidateFormOnly(editingEntity);
        }

        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            counterCustomerChargeMainDispatch(prevState => {
                return {
                    ...prevState,
                    paymentModeState: {
                        ...prevState.paymentModeState,
                        isSaveClicked: true,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });

            const res: ResponseEntity = {
                code: "",
                success: false,
                msg: null,
                data: "missing"
            }

            return res;
        } else {
            counterCustomerChargeMainDispatch(prevState => {
                return {
                    ...prevState,
                    paymentModeState: {
                        ...prevState.paymentModeState,
                        allFormState: {},
                        editingEntity: { ...EMPTY_COLLECTION_DETAIL_ENTITY },
                        isAdd: false,
                    },
                    isShowAddPaymentModePanel: false,
                }
            })

            return await repo.saveCollectionDtlForPayment(editingEntity);
        }
    }

    const onPaymentModeApply = async (criteria: PaymentModeAdditionalInfoCriteria, operatingUnit: string, isAgent: boolean, isCustoms: boolean) => {
        let valResult = null;
        if (operatingUnit === 'AQCT' || operatingUnit === 'RSCT') {
            if (isAgent) {
                valResult = await Validation(createPaymentModeHeaderForAQCTIBValidationSchema).ValidateFormOnly(criteria);
            } else {
                valResult = await Validation(createPaymentModeHeaderForAQCTOBValidationSchema).ValidateFormOnly(criteria);
            }
        }
        /*if (operatingUnit === 'OICT' || operatingUnit === 'HPJZ') {
            if (isAgent && isCustoms) {
                valResult = await Validation(createPaymentModeHeaderValidationSchema).ValidateFormOnly(criteria);
            } else if (isAgent) {
                valResult = await Validation(createPaymentModeHeaderForAgentValidationSchema).ValidateFormOnly(criteria);
            } else if (isCustoms) {
                valResult = await Validation(createPaymentModeHeaderForCustomsValidationSchema).ValidateFormOnly(criteria);
            }
        }*/

        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            counterCustomerChargeMainDispatch(prevState => {
                return {
                    ...prevState,
                    paymentModeState: {
                        ...prevState.paymentModeState,
                        isSaveClicked: true,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });

            const res: ResponseEntity = {
                code: "",
                success: false,
                msg: null,
                data: "missing"
            }

            return res;
        } else {
            return await repo.applyPaymentMode(criteria);
        }
    }

    const onPaymentModeFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;

        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                paymentModeState: {
                    ...prevState.paymentModeState,
                    paymentModeHeader: {
                        ...prevState.paymentModeState.paymentModeHeader,
                        [fieldKey]: val,
                    },
                    allFormState: {
                        ...prevState.paymentModeState.allFormState,
                        [fieldKey]: ''
                    },
                }
            }
        })
    }

    const onPaymentModeAddFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;

        counterCustomerChargeMainDispatch(prevState => {
            let editingEntity = { ...prevState.paymentModeState.editingEntity, [fieldKey]: val };
            let isBankCode = prevState.paymentModeState.isBankCode;
            let isPayOrderNo = prevState.paymentModeState.isPayOrderNo;
            let isPayOrderAmount = prevState.paymentModeState.isPayOrderAmount;
            let isCreditCardNo = prevState.paymentModeState.isCreditCardNo;
            if (fieldKey === 'paymentMode') {
                if (val === 'PO') {
                    isBankCode = true;
                    isPayOrderNo = true;
                    isPayOrderAmount = true;
                    isCreditCardNo = false;
                    editingEntity = { ...editingEntity, creditCardNo: null };
                } else {
                    isBankCode = false;
                    isPayOrderNo = false;
                    isPayOrderAmount = false;
                    if (val === 'POS-CREDIT_CARD') {
                        isCreditCardNo = true;
                        editingEntity = { ...editingEntity, bankCode: null, payOrderNo: null, payOrderAmount: null };
                    } else if (val === 'ONLINE_PAYMENT') {
                        isPayOrderNo = true;
                        isCreditCardNo = true;
                        editingEntity = { ...editingEntity, bankCode: null, payOrderAmount: null };
                    } else {
                        isCreditCardNo = false;
                        editingEntity = { ...editingEntity, bankCode: null, payOrderNo: null, payOrderAmount: null, creditCardNo: null };
                    }
                }
            }
            if (fieldKey === 'paymentAmount' || fieldKey === 'payOrderAmount') {
                const regex1 = /^(\d+)(\.)?(\d{1,2})?$/;
                const regex2 = /^(\d+)(\.)$/;
                if (!_.isEmpty(val)) {
                    if (regex2.test(val)) {
                        val = val + '0';
                    }
                    if (!regex1.test(val) || (Number(fieldValue) < 0 || Number(fieldValue) > 9999999999.99)) {
                        editingEntity = prevState.paymentModeState.editingEntity;
                    }
                }
            }
            return {
                ...prevState,
                paymentModeState: {
                    ...prevState.paymentModeState,
                    editingEntity: editingEntity,
                    allFormState: {
                        ...prevState.paymentModeState.allFormState,
                        [fieldKey]: ''
                    },
                    isBankCode: isBankCode,
                    isPayOrderNo: isPayOrderNo,
                    isPayOrderAmount: isPayOrderAmount,
                    isCreditCardNo: isCreditCardNo,
                }
            }
        })
    }

    const onCollection = async (draftDocNos: string[]) => {
        return await repo.collection(draftDocNos);
    }

    const previewDraftInvoice = async (ids: number[]) => {

        await repo.previewDraftInvoice(ids).then((data) => {
            prevOrDownloadRpt(data, false);
        }).catch((error) => {
            counterCustomerChargeMainDispatch(prevState => {
                return {
                    ...prevState,
                    allFormState: { "previewDocReport": "preview document report error." }
                }
            })
        })
    }

    const onHoldUnHold = async (ids: number[]) => {
        return await repo.holdUnHold(ids);
    }

    const onAccTerminal = async (currentEntity: CounterCustomerChargeEntity[]) => {
        return await repo.accTerminal(currentEntity);
    }

    const isCheckPaidThroughDateForIB = async (currentRows: CounterCustomerChargeEntity[]) => {
        return await repo.isConditionCheckPaidThroughDate(currentRows);
    }

    const onStuffing = async (currentEntity: CounterCustomerChargeEntity[]) => {
        return await repo.stuffing(currentEntity);
    }

    const onImportReHandling = async (criteria: ImportReHandlingCriteria) => {
        return await repo.importReHandling(criteria);
    }

    const getCollectionHdr = async (criteria: PaymentModeAdditionalInfoCriteria, counterCustomerChargeState: CounterCustomerChargeMaintenanceModel) => {
        return await repo.getCollectionHdr(criteria);
    }

    const onCalculatePayment = async (collHdrList: CollectionHeaderEntity[], counterCustomerChargeState: CounterCustomerChargeMaintenanceModel) => {
        return await repo.isCalculatePayment(collHdrList);
    }

    const onCopyPayAmount = (returnPaymentAmount: number) => {
        if (returnPaymentAmount) {
            counterCustomerChargeMainDispatch(prevState => {
                return {
                    ...prevState,
                    paymentModeState: {
                        ...prevState.paymentModeState,
                        servicePayAmount: returnPaymentAmount,
                    }
                }
            })
        }
    }

    const handleCancelClick = () => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                paymentModeState: {
                    ...prevState.paymentModeState,
                    servicePayAmount: 0,
                }
            }
        })
    }

    const onPrintForAQCT = async (draftDocNos: string[]) => {
        await repo.printForAQCT(draftDocNos).then(res => {
            if (res.success && res.data) {
                prevOrDownloadRpt(res.data, false);
            }
        });
    }

    const onAddEditWaiver = (ids: number[]) => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                editWaiverList: { ...prevState.editWaiverList, ids }
            }
        })
    }

    const onAddSuppleWaiver = (ids: number[]) => {
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                suppleWaiverList: { ...prevState.suppleWaiverList, ids }
            }
        })
    }

    const checkChargeDataForMultipleBL = async (criteria: CounterCustomerChargeSearchCriteria) => {
        if (criteria.billOfLadingNo) {
            return await repo.checkChargeDataForMultipleBL(criteria).then(res => {
                return res;
            }).catch(err => {
                return null;
            });
        }
    }

    const getSingOrMultipleBlInfo = (singleMultipleInfoMap: { [key: string]: object }) => {
        if (singleMultipleInfoMap) {
            let cntrNo = singleMultipleInfoMap["CntrNoINCCCM"] as unknown as string;
            let blNo = singleMultipleInfoMap["BillOfLading"] as unknown as string;
            let cntrNoList: string[] = [];
            cntrNoList.push(cntrNo);
            counterCustomerChargeMainDispatch(prevState => {
                return {
                    ...prevState,
                    returnCntrNo: cntrNoList,
                    returnBlNo: blNo
                }
            })
        }
    }

    const refershSearchCriteriaForSingMultipleBL = (cntrNoList: string[], blNo: string, searchCriteria: CounterCustomerChargeSearchCriteria) => {
        let newSearchCriteria = searchCriteria;
        newSearchCriteria = {
            cntrList: cntrNoList,
            billOfLadingNo: blNo
        }
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: newSearchCriteria
            }
        })
    }

    const handleSingBlForSearch = async (searchCriteria: CounterCustomerChargeSearchCriteria) => {
        counterCustomerChargeMainDispatch(prevState => ({
            ...prevState,
            tableData: [],
            selectedRows: [],
            currentSelectedRow: EMPTY_COUNTER_CUSTOMER_CHARGE_ENTITY,
            isBackMaster: false,
            isShowDetailPanel: true,
            paymentModeState: {
                ...prevState.paymentModeState,
                allFormState: {},
                editingEntity: { ...EMPTY_COLLECTION_DETAIL_ENTITY },
                tableData: [],
                paymentModeHeader: { ...EMPTY_PAYMENT_MODE_ADDITIONAL_INFO_CRITERIA },
                isBankCode: false,
                isPayOrderNo: false,
                isPayOrderAmount: false,
                isCreditCardNo: false,
            },
            isShowPaymentModePanel: false,
            singleMultipleValidationMap: {},
        }))
        let tableData: CounterCustomerChargeEntity[] = [];
        await repo.cfsAndUnStuffingDownload(searchCriteria).then(async data => {
            tableData = await repo.searchByCriteria(searchCriteria).then(
                data => {
                    return data;
                }
            );
        });
        counterCustomerChargeMainDispatch(prevState => ({
            ...prevState,
            tableData: tableData,
            searchCriteria: searchCriteria,
            singleMultipleValidationMap: {}
        }))
    }

    const handleMultilpeBlForCopyCharges = async (searchCriteria: CounterCustomerChargeSearchCriteria, singleMultipleInfoMap: { [key: string]: object }) => {
        counterCustomerChargeMainDispatch(prevState => ({
            ...prevState,
            tableData: [],
            selectedRows: [],
            currentSelectedRow: EMPTY_COUNTER_CUSTOMER_CHARGE_ENTITY,
            isBackMaster: false,
            isShowDetailPanel: true,
            paymentModeState: {
                ...prevState.paymentModeState,
                allFormState: {},
                editingEntity: { ...EMPTY_COLLECTION_DETAIL_ENTITY },
                tableData: [],
                paymentModeHeader: { ...EMPTY_PAYMENT_MODE_ADDITIONAL_INFO_CRITERIA },
                isBankCode: false,
                isPayOrderNo: false,
                isPayOrderAmount: false,
                isCreditCardNo: false,
            },
            isShowPaymentModePanel: false,
        }))

        let cntrNo = singleMultipleInfoMap["CntrNoINCCCM"] as unknown as string;
        let blNo = singleMultipleInfoMap["BillOfLadingINCCCM"] as unknown as string;;
        let cntrNoList: string[] = [];
        cntrNoList.push(String(cntrNo));
        searchCriteria = {
            cntrList: cntrNoList,
            billOfLadingNo: blNo,
            singleMultipleInfoMap: singleMultipleInfoMap,
        }
        await repo.copyChargeDataWithMultipleConsignee(searchCriteria).then(async res => {
            if (res && res.success) {
                let newSearchCriteria: CounterCustomerChargeSearchCriteria = { ...searchCriteria };
                newSearchCriteria = {
                    cntrList: cntrNoList,
                    billOfLadingNo: blNo,
                    singleMultipleValidationMap: {}
                }
                let tableData: CounterCustomerChargeEntity[] = [];
                await repo.cfsAndUnStuffingDownload(searchCriteria).then(async data => {
                    tableData = await repo.searchByCriteria(searchCriteria).then(
                        data => {
                            return data;
                        }
                    );
                });
                counterCustomerChargeMainDispatch(prevState => ({
                    ...prevState,
                    tableData: tableData,
                    searchCriteria: newSearchCriteria,
                    singleMultipleValidationMap: {}
                }))
            }
        })

    }

    const isShowPaymentOptional = (tableData: CounterCustomerChargeEntity[], operatingUnit: string) => {
        let isCustomsDec = true;
        let isAgentDate = true;
        if (operatingUnit === 'AQCT' || operatingUnit === 'RSCT') {
            let cntrNos: string[] = [];
            isCustomsDec = false;
            tableData.forEach(async item => {
                if (item.cntrNo && !cntrNos.includes(item.cntrNo)) {
                    cntrNos.push(item.cntrNo);
                    repo.checkAgenDate(item).then(isExist => {
                        if (isExist) {
                            counterCustomerChargeMainDispatch(prevState => ({
                                ...prevState,
                                paymentModeState: {
                                    ...prevState.paymentModeState,
                                    isAgentDate: false,
                                }
                            }))
                        }
                    });
                }
            })
        }

        if (operatingUnit === 'OICT' || operatingUnit === 'HPJZ') {
            if (tableData.some(x => x.chargeType === 'DOC' && x.subChargeType === 'ESN')) {
                isCustomsDec = false;
                isAgentDate = false;
            }
            let noCntrStatueOrtherList: string[] = [];
            let hasContainersList: string[] = [];
            let hasCntrStatueList: string[] = [];
            let noContainersList: string[] = [];
            tableData.forEach(entity => {
                if ((entity.cntrStatus1 && entity.cntrStatus1 !== 'IF' && entity.cntrStatus1 !== 'IM')
                    || (entity.additionalChargeInd === 'Y' && !entity.cntrNo && !entity.cntrStatus1 && entity.soNumber)) {
                    noCntrStatueOrtherList.push(entity.id.toString());
                    if (entity.cntrNo) {
                        hasContainersList.push(entity.cntrNo);
                    }
                } else {
                    hasCntrStatueList.push(entity.id.toString());
                    if (entity.additionalChargeInd !== 'Y' && entity.cntrNo) {
                        hasContainersList.push(entity.id.toString());
                    }
                    if (entity.additionalChargeInd !== 'Y' && !entity.cntrNo) {
                        noContainersList.push(entity.id.toString());
                    }
                }

                if ((noCntrStatueOrtherList.length < 1 || !noCntrStatueOrtherList) && hasCntrStatueList.length > 0) {
                    isCustomsDec = false;
                }
                if ((hasContainersList.length < 1 || !hasContainersList) && noContainersList.length > 0) {//update by Betty
                    isAgentDate = false;
                }
            })
        }
        counterCustomerChargeMainDispatch(prevState => ({
            ...prevState,
            paymentModeState: {
                ...prevState.paymentModeState,
                isCustomsDec: isCustomsDec,
                isAgentDate: isAgentDate,
            }
        }))
    }

    const getOldPaymentMode = (tableData: CounterCustomerChargeEntity[], operatingUnit: string) => {
        if (operatingUnit === 'AQCT' || operatingUnit === 'RSCT') {
            let cntrNos: string[] = [];
            tableData.forEach(async item => {
                if (item.cntrNo && !cntrNos.includes(item.cntrNo)) {
                    cntrNos.push(item.cntrNo);
                    repo.getOldPaymentMode(item).then(data => {
                        if (data) {
                            counterCustomerChargeMainDispatch(prevState => ({
                                ...prevState,
                                isShowPaymentModePanel: true,
                                paymentModeState: {
                                    ...prevState.paymentModeState,
                                    paymentModeHeader: {
                                        ...prevState.paymentModeState.paymentModeHeader,
                                        customsDeclarationNo: data.customsDeclarationNo,
                                        customsDeclarationDate: data.customsDeclarationDate,
                                        agentDeliveryDate: data.agentDeliveryDate,
                                    }
                                }
                            }))
                        }
                    });
                }
            })
        }
    }

    const onCheckBookingCntrNo = async (draftDocNos: string[]) => {
        return await repo.checkBookingCntrNo(draftDocNos);
    }

    const onRejectForBK = async (ids: number[]) => {
        if (ids) {
            return await repo.reject(ids);
        }
    }

    const getDocHdrIds = async (draftDocNos: string[]) => {
        return await repo.getDocHdrIds(draftDocNos);
    }

    const checkBookingChargeCntr = async (ids: number[]) => {
        return await repo.checkBookingChargeCntrWithNgen(ids);
    }

    const updateSelectedAgentDeliveryDateRows = async (selecedRows: AgentDeliveryDateState[]) => {

        const selectedAgentDeliveryMap = new Map<string, Date>(
            selecedRows.map(row => [row.cntrNo, row.agentDeliveryDate])
        );
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                selectedAgentDeliveryDateMap: selectedAgentDeliveryMap
            }
        })
    }
    const updateSelectedPaidThroughDateRows = async (selecedRows: PaidThroughDateState[]) => {

        const selectedPaidThroughDateMap = new Map<string, Date>(
            selecedRows.map(row => [row.cntrNo, row.paidThroughDate])
        );
        counterCustomerChargeMainDispatch(prevState => {
            return {
                ...prevState,
                selectedPaidThroughDateMap: selectedPaidThroughDateMap
            }
        })
    }

    const onApplyClick = (paidThroughDateMap: Map<string, Date>, selectedPaidThroughDateMap: Map<string, Date>) => {
        counterCustomerChargeMainDispatch(prevState => {
            const paidThroughDate = prevState.editingEntity.paidThroughDate;

            if (!paidThroughDate) {
                return prevState;
            }
            const newPaidThroughDateMap = new Map(paidThroughDateMap);

            selectedPaidThroughDateMap.forEach((_, cntrNo) => {
                newPaidThroughDateMap.set(cntrNo, paidThroughDate);
            });

            return {
                ...prevState,
                paidThroughDateMap: newPaidThroughDateMap,
            }
        })
    }

    const onApplyExtensionPaymenClick = (extensionPaymentMap: Map<string, Date>, selectedPaidThroughDateMap: Map<string, Date>) => {
        counterCustomerChargeMainDispatch(prevState => {
            const paidThroughDate = prevState.editingEntity.paidThroughDate;

            if (!paidThroughDate) {
                return prevState;
            }
            const newPaidThroughDateMap = new Map(extensionPaymentMap);

            selectedPaidThroughDateMap.forEach((_, cntrNo) => {
                newPaidThroughDateMap.set(cntrNo, paidThroughDate);
            });

            return {
                ...prevState,
                extensionPaymentMap: newPaidThroughDateMap,
            }
        })
    }

    const onApplyAgentDeliveryClick = (agentDeliveryDateMap: Map<string, Date>, selectedAgentDeliveryDateMap: Map<string, Date>) => {
        counterCustomerChargeMainDispatch(prevState => {
            const agentDeliveryDate = prevState.editingEntity.agentDeliveryDate;

            if (!agentDeliveryDate) {
                return prevState;
            }
            const newAgentDeliveryDateMap = new Map(agentDeliveryDateMap);

            selectedAgentDeliveryDateMap.forEach((_, cntrNo) => {
                newAgentDeliveryDateMap.set(cntrNo, agentDeliveryDate);
            });

            return {
                ...prevState,
                agentDeliveryDateMap: newAgentDeliveryDateMap,
            }
        })
    }

    const copyAdditionalHdrInfo = (counterCusts: CounterCustomerChargeEntity[], editingHdrEntity: CounterCustomerChargeEntity) => {
        return counterCusts?.map(countCust => ({
            ...countCust,
            billOfLading: editingHdrEntity?.billOfLading ?? null,
            shippingBill: editingHdrEntity?.shippingBill ?? null,
            owner1: editingHdrEntity?.owner1 ?? null,
            opsDate: editingHdrEntity?.opsDate ?? null,
            serviceCode: editingHdrEntity?.serviceCode ?? null,
            arrDateTime: editingHdrEntity?.arrDateTime ?? null,
            etd: editingHdrEntity?.etd ?? null,
            agentNo: editingHdrEntity?.agentNo ?? null,
            chargeOnCompany: editingHdrEntity?.chargeOnCompany ?? null,
            billToCompany: editingHdrEntity?.billToCompany ?? null,
            forwarderReference: editingHdrEntity?.forwarderReference ?? null,
            counterCustCompCode: editingHdrEntity?.counterCustCompCode ?? null,
            consortiumCode: editingHdrEntity?.consortiumCode ?? null,
            vesselCode: editingHdrEntity?.vesselCode ?? null,
            voyageCode: editingHdrEntity?.voyageCode ?? null,
            vesselName: editingHdrEntity?.vesselName ?? null,
            poo: editingHdrEntity?.poo ?? null,
            pod1: editingHdrEntity?.pod1 ?? null,
            pol: editingHdrEntity?.pol ?? null,
            fd: editingHdrEntity?.fd ?? null,
        }));
    }

    const onValidationAdjustmentType = async (adjEntity: CounterCustomerChargeEntity) => {
        let result: boolean | null | undefined = undefined;

        result = await Validation(updateAdjustmentValidationSchema).ValidateFormOnly(
            adjEntity
        ).then(res => {
            if (res) {
                counterCustomerChargeMainDispatch(prevState => {
                    return {
                        ...prevState,
                        allFormState: res
                    }
                })
                return false;
            } else {
                return true;
            }
        }).catch(error => {
            return false;
        });
        return result;
    }

    const onValidationBillToCompanyCode = async (companyEntity: CounterCustomerChargeEntity) => {
        let result: boolean | null | undefined = undefined;

        result = await Validation(updateBillToCompanyValidationSchema).ValidateFormOnly(
            companyEntity
        ).then(res => {
            if (res) {
                counterCustomerChargeMainDispatch(prevState => {
                    return {
                        ...prevState,
                        allFormState: res
                    }
                })
                return false;
            } else {
                return true;
            }
        }).catch(error => {
            return false;
        });
        return result;
    }

    const onValidationChargeOnCompanyCode = async (companyEntity: CounterCustomerChargeEntity) => {
        let result: boolean | null | undefined = undefined;

        result = await Validation(updateChargeOnCompanyValidationSchema).ValidateFormOnly(
            companyEntity
        ).then(res => {
            if (res) {
                counterCustomerChargeMainDispatch(prevState => {
                    return {
                        ...prevState,
                        allFormState: res
                    }
                })
                return false;
            } else {
                return true;
            }
        }).catch(error => {
            return false;
        });
        return result;
    }

    const onValidationAccTerminal = async (adjEntity: CounterCustomerChargeEntity) => {
        let result: boolean | null | undefined = undefined;

        result = await Validation(updateAccountTerminalValidationSchema).ValidateFormOnly(
            adjEntity
        ).then(res => {
            if (res) {
                counterCustomerChargeMainDispatch(prevState => {
                    return {
                        ...prevState,
                        allFormState: res
                    }
                })
                return false;
            } else {
                return true;
            }
        }).catch(error => {
            return false;
        });
        return result;
    }

    return {
        onDateRangeChange: onDateRangeChange,
        loadDropdownOption: loadDropdownOption,
        updateSelectedRows: updateSelectedRows,
        onAdd: onAdd,
        onEdit: onEdit,
        onReset: onReset,
        onClose: onClose,
        onSearch: onSearch,
        onSearchClick: onSearchClick,
        onSaveAdditionalEdit: onSaveAdditionalEdit,
        onSave: onSave,
        onCheckboxChange: onCheckboxChange,
        onFieldChange: onFieldChange,
        onEditClick: onEditClick,
        onDropdownChange: onDropdownChange,
        onCoVslVoyChange: onCoVslVoyChange,
        onTextAreaChange: onTextAreaChange,
        onHeaderFieldChange: onHeaderFieldChange,
        onCoVslVoyVelChange: onCoVslVoyVelChange,
        onAdditionalClose: onAdditionalClose,
        onSearchAdditional: onSearchAdditional,
        onAdditionalAdd: onAdditionalAdd,
        onAdditionalEditClose: onAdditionalEditClose,
        onAdditionalFieldChange: onAdditionalFieldChange,
        onApplyAll: onApplyAll,
        onApplyAdditional: onApplyAdditional,
        onConfirmAndSubmit: onConfirmAndSubmit,
        onShowLoading: onShowLoading,
        onHideLoading: onHideLoading,
        onDeleteAdditional: onDeleteAdditional,
        updateAdditionalSelectedRows: updateAdditionalSelectedRows,
        onAdditionalEdit: onAdditionalEdit,
        onMarkMT: onMarkMT,
        previewDocReport: previewDocReport,
        onMore: onMore,
        onMoreClose: onMoreClose,
        onCounterCustomerFieldChange: onCounterCustomerFieldChange,
        onTextAreaChangeCC: onTextAreaChangeCC,
        onEditWaiver: onEditWaiver,
        onSuppleWaiver: onSuppleWaiver,
        onShowPanel: onShowPanel,
        closeCompDialog: closeCompDialog,
        updateAdditionalVesselSelectedRows: updateAdditionalVesselSelectedRows,
        applyVessel: applyVessel,
        onSearchFieldChange: onSearchFieldChange,
        setDocHdrId: setDocHdrId,
        closeCompDialogForPayment: closeCompDialogForPayment,
        onResetForPayment: onResetForPayment,
        onPaymentModeAdd: onPaymentModeAdd,
        onPaymentModeAddClose: onPaymentModeAddClose,
        onPaymentModeAddSave: onPaymentModeAddSave,
        onPaymentModeFieldChange: onPaymentModeFieldChange,
        onPaymentModeAddFieldChange: onPaymentModeAddFieldChange,
        onSearchPaymentMode: onSearchPaymentMode,
        onPaymentModeApply: onPaymentModeApply,
        onCollection: onCollection,
        prevOrDownloadRpt: prevOrDownloadRpt,
        onDelete: onDelete,
        onAdjustment: onAdjustment,
        onCheckAdjustment: onCheckAdjustment,
        onSearchCounterCustomer: onSearchCounterCustomer,
        previewDraftInvoice: previewDraftInvoice,
        onHoldUnHold: onHoldUnHold,
        onAccTerminal: onAccTerminal,
        isCheckPaidThroughDateForIB: isCheckPaidThroughDateForIB,
        onStuffing: onStuffing,
        onImportReHandling: onImportReHandling,
        getCollectionHdr: getCollectionHdr,
        onCalculatePayment: onCalculatePayment,
        onCopyPayAmount: onCopyPayAmount,
        handleCancelClick: handleCancelClick,
        onPrintForAQCT: onPrintForAQCT,
        onAddEditWaiver: onAddEditWaiver,
        onAddSuppleWaiver: onAddSuppleWaiver,
        checkChargeDataForMultipleBL: checkChargeDataForMultipleBL,
        getSingOrMultipleBlInfo: getSingOrMultipleBlInfo,
        refershSearchCriteriaForSingMultipleBL: refershSearchCriteriaForSingMultipleBL,
        handleSingBlForSearch: handleSingBlForSearch,
        handleMultilpeBlForCopyCharges: handleMultilpeBlForCopyCharges,
        isShowPaymentOptional: isShowPaymentOptional,
        getOldPaymentMode: getOldPaymentMode,
        updatePaidThroughDate: updatePaidThroughDate,
        onSaveAdditionalClicked: onSaveAdditionalClicked,
        updateExtensionPayment: updateExtensionPayment,
        onSerachPanl: onSerachPanl,
        onSerachPanlClose: onSerachPanlClose,
        searchAdditionalByCriteria: searchAdditionalByCriteria,
        onCheckBookingCntrNo: onCheckBookingCntrNo,
        onRejectForBK: onRejectForBK,
        getDocHdrIds: getDocHdrIds,
        checkBookingChargeCntr: checkBookingChargeCntr,
        updateSelectedAgentDeliveryDateRows: updateSelectedAgentDeliveryDateRows,
        onApplyAgentDeliveryClick: onApplyAgentDeliveryClick,
        updateSelectedPaidThroughDateRows: updateSelectedPaidThroughDateRows,
        onApplyClick: onApplyClick,
        onApplyExtensionPaymenClick: onApplyExtensionPaymenClick,
        copyAdditionalHdrInfo: copyAdditionalHdrInfo,
        onDeleteClick: onDeleteClick,
        onCancelDelete: onCancelDelete,
        onValidationAdjustmentType: onValidationAdjustmentType,
        onValidationAccTerminal: onValidationAccTerminal,
        onValidationBillToCompanyCode: onValidationBillToCompanyCode,
        onValidationChargeOnCompanyCode: onValidationChargeOnCompanyCode,
    }
}